<!--

    Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
@if (organisationsEinheitResource$ | async; as organisationsEinheitResource) {
  <alfa-zustaendige-stelle-header
    title="Öffentliche Verwaltung"
    [subTitle]="organisationsEinheitResource.name"
    [isSubTitleBold]="true"
  >
    <ods-icon icon name="public-administration" size="full" />
    <p class="text-text text-sm">{{ organisationsEinheitResource.anschrift | anschriftToString }}</p>
    <alfa-edit-zustaendige-stelle-button title="Zuständige Stelle auswählen" dataTestId="edit-organisations-einheit-button" />
  </alfa-zustaendige-stelle-header>
} @else {
  <alfa-zustaendige-stelle-header title="Öffentliche Verwaltung" subTitle="Kommune, Amt, Ministerium">
    <ods-icon icon name="public-administration" size="full" />
    <alfa-zustaendige-stelle-button title="Zuständige Stelle auswählen" dataTestId="organisations-einheit-search-button" />
  </alfa-zustaendige-stelle-header>
}
